module.exports = __webpack_public_path__ + "static/media/lays.2dfe61af.jpeg";